import React from 'react'
import { uptoTwoDecimalRegex } from '../../../helper/genericFunction';
import GenericCustomButton from '../../../genericComponents/GenericCustomButton';
import Icons from '../../../assets/icons';
import GenericInput from '../../../genericComponents/input/GenericInputComponent';
import { useSelector } from 'react-redux';
import LanguageTranslator from '../../../locals/LanguageTranslator';
import { SquarePen } from 'lucide-react';
import GenericToggleComponent from '../../../genericComponents/GenericToggleComponent';

function CreateBoxTab(props) {
    const { setState, createBoxes, boxes, skuWiseBoxes, state, deleteBox, openSkuModal, headersData, headersType, handleQtyInput, toggleViewSKU, totalBoxes, totalCount, poDetails, handleChange, isEdit, uploadExcel, selectedData, getHeaderKey, isBoxTemplateSelectedOrNot } = props;
    const digiVendStore = useSelector(state => state?.digiVendStore)

    let isLoading = () => isEdit ? digiVendStore?.vendorshipFindSrdetailData?.isLoading : digiVendStore?.vendorpoGetPodetailData?.isLoading

    const setColorBasedOnPercentage = (percentage) => {
        if (percentage >= 0 && percentage <= 24) {
            return "bg-green"
        } else if (percentage >= 25 && percentage <= 49) {
            return "bg-yellow"
        } else if (percentage >= 50 && percentage <= 74) {
            return "bg-orange"
        } else {
            return "bg-red"
        }
    }

    const getTotalConsumption = () => {
        let getKey = selectedData?.poType == "poicode" ? "itemConsumedPer" : "setConsumedPer";
        if (poDetails?.length !== 0) {
            let total = poDetails.reduce((acc, item) => {
                let value = Number(item[getKey]);
                return acc + value;
            }, 0);
            total = (total / poDetails?.length)?.toFixed(2)
            return total
        }
        else return 0
    }

    const isEditSkuIsEnabled = (item) => {
        return isEdit && item?.boxNumber && (props.editresponse?.boxes?.length > 1 || (props.editresponse?.boxes?.length == 1 && props.editresponse?.boxes?.[0]?.box_count > 1));
    }

    const totalConsumption = !isEdit ? getTotalConsumption() : 0;

    return (
        <div className='box-id-generation-modal'>
            <div className="bigb-top m-bot-20">
                <div className="bigbt-left flex">
                    <GenericCustomButton disabled={isBoxTemplateSelectedOrNot?.() || (isEdit && boxes?.[0]?.boxTemplateId)} className='!flex !items-center !gap-1.5' leftIcon={<Icons.PlusIcon />} onClick={() => handleChange('addSkus', 1)} label="Add Box" type='primary' />
                    <GenericCustomButton disabled={isBoxTemplateSelectedOrNot?.() || (isEdit && boxes?.[0]?.boxTemplateId)} onClick={() => handleChange('scanNPack')} label="Scan N Pack" type='default' />
                </div>
                <div className="bigbt-right">

                    {!props?.isEdit && (state?.mixedBoxesAllowedInThisPo || state?.mixedBoxesAllowed || state?.mixedSKUPerBox)&& <div className='flex items-center gap-2 mr-1'>
                        <LanguageTranslator tag='label' className='cambst-create-text mb-0 text-xs font-semibold text-[#111D31]'>Request Qty.</LanguageTranslator>
                        <div className='cambstr-toggle'>
                            {/* state?.boxCreation ? bootConfig?.additionalConfig?.color : */}
                            <GenericToggleComponent
                                style={{ fontFamily: 'poppins' }}
                                checked={props.isAllQtyZero}
                                checkedComponent="Zero"
                                uncheckedComponent="Default"
                                onChange={() => {
                                    handleChange("updateQtyZero")
                                }}
                            />
                            <LanguageTranslator tag='span' className='generic-tooltip'>Cannot toggle while editing</LanguageTranslator>
                        </div>
                    </div>}

                    {(!isEdit && (headersData?.[getHeaderKey]?.[headersType?.[getHeaderKey]].hasOwnProperty("setConsumedPer") || headersData?.[getHeaderKey]?.[headersType?.[getHeaderKey]].hasOwnProperty("itemConsumedPer"))) && <div className='flex items-center mr-2'>
                        <span className='font-[500] text-[#21314b] text-[11px] mr-2'><LanguageTranslator>Total Consumption</LanguageTranslator> % :</span>
                        <span className={`consumption-per ${setColorBasedOnPercentage(totalConsumption)}`}>{totalConsumption}%</span>
                    </div>}
                    {/* Empty Carton Weight removed from Line Items and added in Create Box (With The Concern Of @Deepak) */}
                    <div className="bigbt-right">
                        <GenericInput isDisabled={isEdit} type="text" value={state?.emptyCartonWeight} placeholder='Empty Carton Weight'
                            onChange={(e) => uptoTwoDecimalRegex(e?.target?.value) && setState({ ...state, emptyCartonWeight: e.target.value })}
                            onBlur={() => createBoxes()} iconRight={<span className="l-length">gm</span>}
                        />
                    </div>
                    {/* <div class="bigb-upload-download opacity04 m-lft-10">
                        <label>
                            <input type="file" disabled onChange={(e) => uploadExcel(e)} accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
                            Upload Excel
                        </label>
                        <GenericCustomButton className="bigbud-arrow" rightIcon={<Icons.DownArrowSmall />} />
                    </div> */}
                </div>
            </div>
            <div className="bigb-bottom">
                <div className="create-price-list-table act-table">
                    <div className="cplt-manage">
                        <table className="table">
                            <thead>
                                <tr>
                                    {!isEdit && <th></th>}
                                    {isEdit && <th><label>Box Number</label></th>}
                                    <th><label>Box ID</label></th>
                                    <th><label>Number of SKU</label></th>
                                    <th><label>Per Box quantity</label></th>
                                    <th><label>Per Box weight(kg) <span className="mandatory">*</span></label></th>
                                    <th><label>Total boxes</label></th>
                                    <th colSpan="2"><label>Total quantity</label></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading() ? <tr>
                                    <LanguageTranslator tag="td" colSpan={100}>Fetching Data...</LanguageTranslator>
                                </tr> :
                                    boxes.length === 0 ?
                                        <tr><td colSpan={10} align='center'><label>Click on "Add Box" to get started</label></td></tr> :
                                        boxes?.map((item, index) => {
                                            let noOfSKU = 0, perBoxQty = 0;
                                            Object.values(skuWiseBoxes).forEach(value => {
                                                if (value[index] && value[index] !== null) {
                                                    noOfSKU++;
                                                    perBoxQty += Number(value[index])
                                                }
                                            });
                                            return (
                                                <React.Fragment key={item.id}>
                                                    <tr id={`boxLineRow${index}`} className={item.viewSKU ? "cpl-tr-expanded" : ""}>
                                                        {!isEdit && <td className="fix-action-btn width80">
                                                            <ul class="table-item-list">
                                                                <li className="til-inner til-delete-btn" onClick={() => deleteBox(index)}>
                                                                    {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 15.691 18.83">
                                                                    <path fill="#a4b9dd" id="prefix__iconmonstr-trash-can-2" d="M7.492 14.907a.785.785 0 0 1-1.569 0V7.061a.785.785 0 0 1 1.569 0zm3.138 0a.785.785 0 0 1-1.569 0V7.061a.785.785 0 0 1 1.569 0zm3.138 0a.785.785 0 0 1-1.569 0V7.061a.785.785 0 0 1 1.569 0zm3.923-13.338v1.569H2V1.569h4.481C7.187 1.569 7.76.707 7.76 0h4.17c0 .707.573 1.569 1.28 1.569zm-2.353 3.138v12.554H4.354V4.707H2.785V18.83h14.122V4.707z" transform="translate(-2)" />
                                                                </svg> */}
                                                                    <Icons.DeleteIcon />
                                                                    <span className="generic-tooltip">Delete</span>
                                                                </li>
                                                            </ul>
                                                        </td>}
                                                        {isEdit && <td><label className="bold">{item?.boxNumber}</label></td>}
                                                        {/* On click of the box id we will try to edit the box id */}
                                                        <td>
                                                            <div className='flex items-center justify-between gap-4'>
                                                                <div>
                                                                    <label className="bold"><span className='cpltr-blue'>{state?.boxPrefix}</span>  / <span className='cpltr-green'>{isEdit ? item?.id : index + 1}</span></label>
                                                                </div>

                                                                {isEditSkuIsEnabled(item) && <GenericCustomButton
                                                                    leftIcon={<SquarePen size={14} className='shrink-0' />}
                                                                    onClick={() => isEdit && handleChange("editBoxId", { ...item, boxPrefix: state?.boxPrefix })}
                                                                    className={'p-[4px] rounded-[3px] flex items-center justify-center text-fontBlack text-xs font-medium hover:text-primary'}
                                                                // disabled={item.boxCount == 1}

                                                                />}
                                                            </div>

                                                        </td>


                                                        <td><label>{noOfSKU}</label></td>
                                                        <td><label>{perBoxQty}</label></td>
                                                        <td><input type="text" name="boxWeight" disabled={isEdit ? false : state?.weightMandatory === "Mandatory"} data-index={index} value={item.boxWeight} onChange={(e) => handleQtyInput(e, "D")} /></td>
                                                        {state?.fixedTotalBoxCount ?
                                                            <td><label>{item.boxCount}</label></td>
                                                            : <td>
                                                                <div className={`relative w-fit ${item.boxCountError ? 'group' : ''}`}>
                                                                    <input className={`${item.boxCountError ? '!border !border-danger' : ''}`} autoComplete="off" type="text" name="boxCount" data-index={index} value={item.boxCount} onChange={(e) => handleQtyInput(e, "I")} disabled={isEdit && item?.boxTemplateId} />
                                                                    {(item.boxCountError && <span className="table-tooltip !top-[-20px] group-hover:visible group-hover:opacity-100">{item.boxCountError}</span>)}
                                                                </div>
                                                            </td>
                                                        }
                                                        <td><input type="text" autoComplete="off" disabled name="totalCount" data-index={index} value={perBoxQty * item.boxCount} /></td>
                                                        <td>
                                                            <div className="bigb-add-sku">
                                                                <GenericCustomButton disabled={isBoxTemplateSelectedOrNot?.()} label="Manage SKU" className="bigbas-add" onClick={() => openSkuModal(index)} />
                                                                <button type="button" className="bigbas-view" data-index={index} onClick={(e) => toggleViewSKU(e)}>{item.viewSKU ? "Hide" : "View"}</button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    {item.viewSKU &&
                                                        <tr>
                                                            <td colSpan="7" className="pad-0 bigb-expand-td">
                                                                <div className="create-price-list-table act-table">
                                                                    <div className="cplt-manage">
                                                                        <table className="table">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th><label>Requested quantity</label></th>
                                                                                    {headersData?.[getHeaderKey]?.[headersType?.[getHeaderKey]] && Object.keys(headersData?.[getHeaderKey]?.[headersType?.[getHeaderKey]]).map(key =>
                                                                                        <th key={key}>
                                                                                            <label>{headersData?.[getHeaderKey]?.[headersType?.[getHeaderKey]][key]}</label>
                                                                                        </th>)}
                                                                                </tr>
                                                                            </thead>

                                                                            <tbody>
                                                                                {poDetails?.map(innerItem =>
                                                                                    skuWiseBoxes?.[innerItem.id]?.[index] === null ? null :
                                                                                        <tr key={innerItem.id}>
                                                                                            <td><label>{skuWiseBoxes[innerItem.id][index]}</label></td>
                                                                                            {headersData?.[getHeaderKey]?.[headersType?.[getHeaderKey]] && Object.keys(headersData?.[getHeaderKey]?.[headersType?.[getHeaderKey]]).map(key =>
                                                                                                <td key={key}>
                                                                                                    <label>{innerItem[key]}</label>
                                                                                                </td>)}
                                                                                        </tr>
                                                                                )}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    }
                                                </React.Fragment>
                                            );
                                        })}
                            </tbody>
                        </table>
                    </div>
                    <div className="new-gen-pagination">
                        <div className="ngp-left">
                            <div className="table-page-no">
                                <span className='skut-text'><LanguageTranslator>Total Box added</LanguageTranslator>: </span>
                                <span class="bold">{totalBoxes ? totalBoxes : 0}</span>
                            </div>
                            <div className="table-page-no">
                                <span className='skut-text'><LanguageTranslator>Total Quantity added</LanguageTranslator>: </span>
                                <span class="bold">{totalCount ? totalCount : 0}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateBoxTab